import { useState, useCallback, useEffect } from 'react';
import { ExploreElement } from '../models/ExploreElementModel/ExploreElementModel';
import { logger } from 'services/Logger';

export interface ContestSelectionState {
  selectedContestId: string | null;
  selectContest: (contestId: string) => void;
  deselectContest: () => void;
  isSelected: (contestId: string) => boolean;
  checkContestCompletion: (
    contestId: string,
    runCount: number,
    maxRuns: number
  ) => void;
}

export const useContestSelection = (): ContestSelectionState => {
  // ✅ ERWEITERT: Lade aus localStorage beim Start
  const [selectedContestId, setSelectedContestId] = useState<string | null>(
    () => {
      try {
        const saved = localStorage.getItem('selectedContestId');
        return saved || null;
      } catch {
        return null;
      }
    }
  );

  // ✅ NEU: Speichere in localStorage bei Änderungen
  useEffect(() => {
    try {
      if (selectedContestId) {
        localStorage.setItem('selectedContestId', selectedContestId);
      } else {
        localStorage.removeItem('selectedContestId');
      }
    } catch (error) {
      logger.warn('Failed to save contest selection to localStorage:', error);
    }
  }, [selectedContestId]);

  const selectContest = useCallback((contestId: string) => {
    setSelectedContestId((prev) => (prev === contestId ? null : contestId));
  }, []);

  const deselectContest = useCallback(() => {
    setSelectedContestId(null);
  }, []);

  const isSelected = useCallback(
    (contestId: string) => {
      return selectedContestId === contestId;
    },
    [selectedContestId]
  );

  // ✅ NEU: Automatische Deselection wenn Contest abgeschlossen
  const checkContestCompletion = useCallback(
    (contestId: string, runCount: number, maxRuns: number) => {
      if (selectedContestId === contestId && runCount >= maxRuns) {
        setSelectedContestId(null);
      }
    },
    [selectedContestId]
  );

  return {
    selectedContestId,
    selectContest,
    deselectContest,
    isSelected,
    checkContestCompletion, // ✅ NEU: Export completion check
  };
};
